import { useState } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'

export function LecturerLayout() {
  const { user, logout } = useAuth()
  const [attendanceOpen, setAttendanceOpen] = useState(false)
  const [teachingOpen, setTeachingOpen] = useState(false)
  const initials = (user?.first_name || user?.username || 'LC').slice(0, 2).toUpperCase()

  return (
    <div className="flex h-full overflow-hidden">
      <aside className="flex w-64 flex-col justify-between overflow-y-auto bg-slate-900 text-slate-300">
        <div>
          <div className="flex items-center gap-3 border-b border-slate-800 p-5">
            <div className="rounded-lg bg-emerald-600 p-2 text-white">
              <i className="fa-solid fa-chalkboard-user text-xl" />
            </div>
            <div>
              <h1 className="text-lg leading-tight font-bold text-white">Academic Portal</h1>
              <span className="text-xs font-medium tracking-wider text-emerald-500 uppercase">
                Lecturer
              </span>
            </div>
          </div>
          <nav className="space-y-1 p-4 text-sm">
            <NavLink
              to="/lecturer"
              end
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2.5 ${
                  isActive
                    ? 'bg-emerald-600 font-medium text-white'
                    : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                }`
              }
            >
              <i className="fa-solid fa-chart-pie w-5" /> Overview
            </NavLink>
            <NavLink
              to="/lecturer/courses"
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2.5 ${
                  isActive
                    ? 'bg-emerald-600 font-medium text-white'
                    : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                }`
              }
            >
              <i className="fa-solid fa-book-open w-5" /> My Courses
            </NavLink>

            <div>
              <button
                type="button"
                onClick={() => setAttendanceOpen((v) => !v)}
                className="flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-slate-400 hover:bg-slate-800 hover:text-white"
              >
                <span className="flex items-center gap-3">
                  <i className="fa-solid fa-user-check w-5" /> Attendance
                </span>
                <i
                  className={`fa-solid fa-chevron-down text-xs transition ${attendanceOpen ? 'rotate-180' : ''}`}
                />
              </button>
              {attendanceOpen && (
                <div className="space-y-1 py-1 pr-2 pl-9 text-xs">
                  <NavLink to="/lecturer/attendance" className="block py-1.5 text-slate-400 hover:text-white">
                    Open Session
                  </NavLink>
                </div>
              )}
            </div>

            <div>
              <button
                type="button"
                onClick={() => setTeachingOpen((v) => !v)}
                className="flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-slate-400 hover:bg-slate-800 hover:text-white"
              >
                <span className="flex items-center gap-3">
                  <i className="fa-solid fa-graduation-cap w-5" /> Teaching
                </span>
                <i
                  className={`fa-solid fa-chevron-down text-xs transition ${teachingOpen ? 'rotate-180' : ''}`}
                />
              </button>
              {teachingOpen && (
                <div className="space-y-1 py-1 pr-2 pl-9 text-xs">
                  <NavLink to="/lecturer/materials" className="block py-1.5 text-slate-400 hover:text-white">
                    Notes & Materials
                  </NavLink>
                  <NavLink to="/lecturer/assessments" className="block py-1.5 text-slate-400 hover:text-white">
                    Assessments
                  </NavLink>
                </div>
              )}
            </div>
          </nav>
        </div>
        <div className="flex items-center justify-between border-t border-slate-800 p-4">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-700 font-bold text-white">
              {initials}
            </div>
            <div>
              <p className="text-sm font-medium text-white">
                {user?.first_name || user?.username}
              </p>
              <p className="text-xs text-slate-500">Lecturer</p>
            </div>
          </div>
          <button type="button" onClick={logout} className="text-slate-400 hover:text-red-400" title="Logout">
            <i className="fa-solid fa-right-from-bracket" />
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto bg-slate-50">
        <Outlet />
      </main>
    </div>
  )
}
